import React from 'react';
import UserProductView from './UserProductView';
import DeveloperProductView from './DeveloperProductView';
import ResultsHeaderView from './ResultsHeaderView';
import ResultsZeroStateView from './ResultsZeroStateView';
import Feedback from './Feedback';
import Card from 'kepler/lib/components/Card';
import Loader from 'kepler/lib/components/Loader';
import PropTypes from 'prop-types';
import {
  productsToFPTIMapping,
  productCountryVariations
} from '../lib/quizStaticMapping';
import { extend, get } from 'lodash';
class RecommendedProduct extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userProducts: props.userProducts,
      developerProducts: props.developerProducts,
      shouldShowZeroState: 0,
      maxLength:
        Object.keys(props.userProducts).length +
        (props.developerProducts
          ? Object.keys(props.developerProducts).length
          : 0),
      submittingResult: false
    };
  }
  handleClicks = e => {
    const { location, fptiHelper } = this.props;
    if (e.target.classList.contains('reset-quiz-results')) {
      fptiHelper.fptiClick({
        page: `main:businessweb:mep:dashboard:main:quiz:zero_setup_stage`,
        entry_point: get(location, 'search', '').includes('appcenter=true'),
        link: 'restore_prev_recomm'
      });
      const { userProducts, developerProducts } = this.state,
        finalState = { shouldShowZeroState: 0 };
      finalState.userProducts = this.clearProducts(userProducts);
      if (developerProducts) {
        finalState.developerProducts = this.clearProducts(developerProducts);
      }
      this.setState(finalState);
    }
  };
  clearProducts(productObj) {
    let clearedObj = {};
    Object.keys(productObj).forEach(productKey => {
      clearedObj[productKey] = {
        ...productObj[productKey],
        isCollapsed: false
      };
    });
    return clearedObj;
  }
  toggleProduct = (productName, shouldBeOpen, typeOfProductToToggle) => {
    const { userProducts, developerProducts } = this.state;
    let productObj =
      typeOfProductToToggle === 'userProducts'
        ? userProducts
        : developerProducts;
    this.hideUnhideProductTracking(shouldBeOpen, productName);
    Object.keys(productObj).map(productKey => {
      if (productName === productKey) {
        this.setState(prevState => {
          return {
            [typeOfProductToToggle]: {
              ...prevState[typeOfProductToToggle],
              [productKey]: {
                ...prevState[typeOfProductToToggle][productKey],
                isCollapsed: shouldBeOpen
              }
            },
            shouldShowZeroState: shouldBeOpen
              ? (prevState.shouldShowZeroState += 1)
              : (prevState.shouldShowZeroState -= 1)
          };
        });
      }
    });
  };
  hideUnhideProductTracking = (shouldBeOpen, productName) => {
    const { location, fptiHelper } = this.props;
    let productSplit = get(productsToFPTIMapping, `${productName}`, '').split(
        ':'
      ),
      options = {
        page: 'main:businessweb:mep:dashboard:main:quiz:results',
        prod: productSplit[0],
        entry_point: get(location, 'search', '').includes('appcenter=true')
      };
    if (shouldBeOpen) extend(options, { link: 'hide' });
    else extend(options, { link: 'undo' });
    if (productSplit[1]) {
      extend(options, { product_type: productSplit[1] });
    }
    fptiHelper.fptiClick(options);
  };
  submitResults = arrayOfTypes => {
    const { app, location, fptiHelper } = this.props,
      legalCountry = get(app, 'legalCountry');
    fptiHelper.fptiClick({
      page: `main:businessweb:mep:dashboard:main:quiz:results`,
      entry_point: get(location, 'search', '').includes('appcenter=true'),
      link: 'start_setup'
    });
    this.setState({ submittingResult: true });
    let finalProductsArr = [];
    arrayOfTypes.forEach(type => {
      let productsObj = this.state[type];
      if (productsObj) {
        Object.keys(productsObj).forEach(key => {
          if (
            !productsObj[key].isCollapsed &&
            !productsObj[key].isProductCompleted
          ) {
            let productCountryVariation = get(
              productCountryVariations,
              key,
              {}
            );
            if (
              get(productCountryVariation, 'countries', []).includes(
                legalCountry
              )
            ) {
              key = get(productCountryVariation, 'rpsKey');
            }
            finalProductsArr.push(key);
          }
        });
      }
    });
    fetch('/merchantapps/api/v1/recordIntent', {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify(finalProductsArr),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': app.csrf
      }
    }).then(() => {
      window.location = '/mep/dashboard';
    });
  };
  render() {
    const {
      userProducts,
      developerProducts,
      shouldShowZeroState,
      maxLength,
      submittingResult
    } = this.state;
    const { app, location, fptiHelper } = this.props;
    return (
      <Card className="quiz-result-reset-parent" onClick={this.handleClicks}>
        <Loader
          key="loading"
          show={submittingResult}
          type="fixed"
          priority={10}
        />
        <ResultsHeaderView
          shouldShowZeroState={shouldShowZeroState}
          maxLength={maxLength}
          submitResults={this.submitResults}
        />
        {developerProducts && (
          <DeveloperProductView
            developerProducts={developerProducts}
            toggleProduct={this.toggleProduct}
            app={app}
            location={location}
            fptiHelper={fptiHelper}
          />
        )}
        <UserProductView
          userProducts={userProducts}
          toggleProduct={this.toggleProduct}
          location={location}
          fptiHelper={fptiHelper}
        />
        <Feedback location={location} fptiHelper={fptiHelper} />
        <ResultsZeroStateView
          shouldShowZeroState={shouldShowZeroState}
          maxLength={maxLength}
          submitResults={this.submitResults}
          location={location}
          fptiHelper={fptiHelper}
        />
      </Card>
    );
  }
}
RecommendedProduct.propTypes = {
  userProducts: PropTypes.object,
  developerProducts: PropTypes.object,
  app: PropTypes.object,
  location: PropTypes.object,
  fptiHelper: PropTypes.object
};
export default RecommendedProduct;
